




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
const FontEdit: any = require('../../assets/font/FontEdit/FontEdit');
import '../../assets/font/FontEdit/FontEdit.css';
import MapResolver from '../../util/MapResolver';
import { Injectable, Container } from 'ca-middleware';

@Component({
  name: 'LayoutThematicMap',
  mixins: [MapResolver],
})
export default class LayoutThematicMap extends Vue {
  @Injectable() public container!: Container;
  public mapComponent: any;
  @Prop() public options: any;
  private inputTitle: string = '专题图名称';
  private inputUnit: string = '制作单位';
  private scaleSize: string = '100 km';
  private scaleLength: string = '30px';
  private pickerTime: any = '';
  private mapDom: any;
  private mapDomClassName: any = [];
  private mapParentDom: any;
  constructor() {
      super();
  }

  // ----------导出图片-----------
  public reset() {
    this.mapParentDom.prepend($(this.mapDom));
    for (const className of this.mapDomClassName) {
      jQuery(this.mapDom).addClass(className);
    }
    this.mapComponent.updateMapViewSize(
      this.mapParentDom.width(),
      this.mapParentDom.height(),
    );
    // 显示比例尺
    $('.ol-scale-line').show();
  }
  private toExportPic() {
    this.mapComponent.download({
      domId: 'thematicMapOut',
      name: '专题图',
    });
  }

  // -------文字编辑--------
  private fontEditInit() {
    $('.inputTitleClass').bind('contextmenu', (e: any) => {
      return false;
    });
    $('.inputTitleClass').mousedown((e) => {
      if (3 === e.which) {
        $('#font_edit').fadeIn();
        FontEdit($('.inputTitleClass .el-input__inner'));
      }
    });
    $('.inputUnitClass').bind('contextmenu', (e) => {
      return false;
    });
    $('.inputUnitClass').mousedown((e) => {
      if (3 === e.which) {
        $('#font_edit').fadeIn();
        FontEdit($('.inputUnitClass .el-input__inner'));
      }
    });
  }

  // -----关闭---------------
  private closeClick() {
    $('.emap_control_thematicMap').fadeOut();
    $('#font_edit').fadeOut();
    this.$emit('closeGisThematicMapState');
  }

  private mounted() {
    // 获取地图，地图加载完成后进入回调
    const self: any = this;
    self.resolveMap(this.options.mapId).then((event1: any) => {
      self.mapComponent = new window.G.common.ThematicMap({
        map: event1.map,
      });
      self.mapComponent.load();
      // 比例尺事件注册
      self.mapComponent.on('update-scale', (event: any) => {
        self.scaleSize = event.scaleText;
        self.scaleLength = event.width;
        $('.mapBottomScale hr').css('width', self.scaleLength);
        // $(".mapBottomScaleText").html(this.scaleSize);
      });
      // 地图dom操作
      self.mapDom = self.mapComponent.getMapDom();
      const classNames: any = (self.mapDom.className + '').trim().split(' ');
      for (let i = 0; i < classNames.length; i++) {
        classNames[i] = classNames[i].trim();
        jQuery(self.mapDom).removeClass(classNames[i]);
      }
      self.mapDomClassName = classNames;
      self.mapParentDom = jQuery(self.mapDom).parent();
      $('.mapContainer').prepend($(self.mapDom));
      self.mapComponent.updateMapViewSize(
        $('.mapContainer').width(),
        $('.mapContainer').height(),
      );
      // // 比例尺更新
      const scaleData = self.mapComponent.getScale();
      self.scaleSize = scaleData.scaleText;
      self.scaleLength = scaleData.width;
      // $(".mapBottomScaleText").html(this.scaleSize);
      $('.mapBottomScale hr').css('width', self.scaleLength);
      self.fontEditInit();
    });
    // 隐藏比例尺
    $('.ol-scale-line').hide();
  }

  private beforeDestroy() {
    this.reset();
  }
}
